import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { PivotListTemplate } from "themes/application/pivot/pages";
import { PivotListViewStore } from "application/pivot/stores";

@setCurrentView(rootStore => new PivotListViewStore(rootStore), "pivotListViewStore")
@observer
class PivotList extends React.Component {
    render() {
        return <PivotListTemplate {...this.props} />;
    }
}

export default PivotList;